import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupLocalModel } from '../types';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export function useBackupLocalSettings<T = BackupLocalModel>({
  select,
  enabled,
}: {
  select?: (settings: BackupLocalModel) => T;
  enabled?: boolean;
} = {}) {
  return useQuery(queryKeys.backupLocalSettings(), getBackupLocalSettings, {
    select,
    enabled,
    ...withError('Unable to retrieve local backup settings'),
  });
}

async function getBackupLocalSettings() {
  try {
    const { data } = await axios.get<BackupLocalModel>(
      buildUrl('local', 'settings')
    );

    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to retrieve local backup settings'
    );
  }
}
